import React from 'react';
import PropTypes from 'prop-types';
import { pages } from '../constants';
import withContentful from '../withContenfull';
import MainBanner from './MainBanner';
import Tabs from './Tabs';

const Responsibility = ({ site }) => (
  <>
    <MainBanner site={site} />
    <Tabs site={site} />
  </>
);

Responsibility.propTypes = {
  site: PropTypes.object,
};

export default withContentful(pages.responsibility)(Responsibility);
